import { render } from "./PollStudents.vue?vue&type=template&id=5c96d79c&scoped=true"
import script from "./PollStudents.vue?vue&type=script&lang=js"
export * from "./PollStudents.vue?vue&type=script&lang=js"

import "./PollStudents.vue?vue&type=style&index=0&id=5c96d79c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c96d79c"]])

export default __exports__